module.exports = __webpack_public_path__ + "static/img/1692694648659.da39358a.jpg";